import Commons from '../../../../Services/Common/Common';

export const M_TBG_CUSTOM_07_Schema = {
  mapper: {
    search1: {
      TbmCd: (context) => Commons.EncryptAES(context.tbmCd ?? '') || '',
    },
    save1: {
      TbmCd: (row) => Commons.EncryptAES(row.tbmCd ?? '') || '',
      TbmAddMeeting: (row) =>
        Commons.EncryptAES(row.tbmAddMeeting ?? '') || '',
      TbmAddMeetingTime: (row) =>
        Commons.EncryptAES(String(row.tbmAddMeetingTime) ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
    save2: {
      TbmCd: (row) => Commons.EncryptAES(row.tbmCd) || '',
      EStep: (row) => Commons.EncryptAES(String(row.eStep ?? '')) || '',
      MStep: (row) => Commons.EncryptAES(String(row.mStep ?? '')) || '',
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};
